import React from "react";

const Ul = ({
  className,
  style,
  onClick,
  onDoubleClick,
  onMouseOver,
  onMouseOut,
  children,
  layerRef
}) => {
  return (
    <ul
      ref={layerRef}
      className={className}
      style={style}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {children}
    </ul>
  );
};

export default Ul;
